export const MusicPaths = {
  AMBIENT1: "ambient/ambient-1",
  AMBIENT2: "ambient/ambient-2",
  AMBIENT3: "ambient/ambient-3",
  AMBIENT4: "ambient/ambient-4",
  ACTION1: "action/action-1",
};
